module.exports = __webpack_public_path__ + "static/media/YM53_3.b13971a8.jpg";